"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AxisIndex = exports.__parse_sliceRange = exports.AxesIndex = exports.index = void 0;
//@ts-check
var basic_1 = require("./basic");
var dtypes_1 = require("../dtypes");
function index(arr, where) {
    // This can result either in a value, a view, a copy.
    // The index is simple if there are only ranges, numbers, ":" and at most one "..."
    // If index is simple, don't call ".indices" and make view
    // If index is advanced, get indices and make copy
    var copy = false;
    if (!((0, basic_1.isarray)(arr)))
        throw new Error("Expected NDArray. Found ".concat(typeof arr, ": ").concat(arr));
    var axesIndex = AxesIndex.prototype.parse(arr.shape, where);
    if (axesIndex.isConstant && arr.shape.length == 1) {
        var _a = __read(axesIndex.indices, 1), index_1 = _a[0];
        return arr.flat[index_1];
    }
    else if (axesIndex.isSimple) {
        var composition = __compose_simpleIndexes(arr._simpleIndexes, axesIndex);
        var out = (0, basic_1.new_NDArray)(arr._flat, axesIndex.shape);
        out._simpleIndexes = composition;
        if (arr['__warnAssignments'])
            out['__warnAssignments'] = true;
        return copy ? out.copy() : out;
    }
    else {
        var src_flat_1 = arr.flat;
        var buffer = arr.dtype.from(axesIndex.indices.map(function (i) { return src_flat_1[i]; }));
        var out = (0, basic_1.new_NDArray)(buffer, axesIndex.shape);
        if (!copy)
            out['__warnAssignments'] = true;
        return out;
    }
}
exports.index = index;
// type SimpleIndexes = null | { size: number, ranges: { refSize: number, range: null | number | [number, number, number] }[], indices: null | number[] };
var AxesIndex = /** @class */ (function () {
    /**
     * @param {AxisIndex[]} axisIndexes
     */
    function AxesIndex(apparentShape, internalShape, axisIndexes) {
        this.shape = apparentShape;
        this.internalShape = internalShape;
        this.axisIndexes = axisIndexes;
        this._indices = null;
        this._size = null;
        this.isSimple = this.axisIndexes.map(function (idx) { return idx.isSimple; }).reduce(function (a, b) { return a && b; }, true);
        this.isConstant = this.axisIndexes.map(function (idx) { return idx.isConstant; }).reduce(function (a, b) { return a && b; }, true);
    }
    Object.defineProperty(AxesIndex.prototype, "indices", {
        get: function () {
            if (this._indices)
                return this._indices;
            var indices = __slices_to_indices(this.internalShape, this.__slices);
            return this._indices = indices;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AxesIndex.prototype, "__slices", {
        get: function () {
            return this.axisIndexes.map(function (idx) { return idx.indices; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AxesIndex.prototype, "size", {
        get: function () {
            if (this._size !== null)
                return this._size;
            return this._size = this.axisIndexes.map(function (idx) { return idx.size; }).reduce(function (a, b) { return a * b; }, 1);
        },
        enumerable: false,
        configurable: true
    });
    return AxesIndex;
}());
exports.AxesIndex = AxesIndex;
function __compose_simpleIndexes(first, second) {
    if (first == null)
        return second;
    var axisIndexes = [];
    // console.log({ first, second })
    var j = 0;
    for (var i = 0; i < first.axisIndexes.length; i++) {
        var specA = first.axisIndexes[i].spec;
        var specB = second.axisIndexes[j].spec;
        if (specA.type == "array")
            throw new Error("Expected simple index. Found advanced: ".concat(specA.type));
        if (specB.type == "array")
            throw new Error("Expected simple index. Found advanced: ".concat(specB.type));
        var spec = void 0;
        if (specA.type == "number")
            spec = specA;
        else {
            j++;
            if (specA.type === false)
                spec = specA;
            else if (specB.type === false)
                spec = specB;
            else if (specA.type == ":")
                spec = specB;
            else if (specB.type == ":")
                spec = specA;
            else {
                var _a = specA.range, startA = _a.start, stepA = _a.step, nStepsA = _a.nSteps;
                if (specB.type == "number") {
                    var index_2 = specB.index;
                    if (index_2 < 0)
                        index_2 = nStepsA + index_2;
                    if (index_2 < 0 || index_2 >= nStepsA)
                        throw new Error("Index ".concat(index_2, " out of bounds [0..").concat(nStepsA, ")"));
                    index_2 = startA + index_2 * stepA;
                    spec = { type: "number", index: index_2 };
                }
                else {
                    var _b = specB.range, startB = _b.start, stepB = _b.step, nStepsB = _b.nSteps;
                    var sub = AxisIndex.prototype.parse_range(nStepsA, startB, startB + nStepsB * stepB, stepB);
                    var step = sub.step * stepA;
                    var start = startA + sub.start * step;
                    var nSteps = sub.nSteps;
                    spec = { type: "range", range: { start: start, step: step, nSteps: nSteps } };
                }
            }
        }
        axisIndexes.push(new AxisIndex(spec));
    }
    if (j < second.axisIndexes.length)
        throw new Error("Index too long. Expected ".concat(j, " axes. Found ").concat(second.axisIndexes.length));
    var apparentShape = second.shape;
    var internalShape = first.internalShape;
    return new AxesIndex(apparentShape, internalShape, axisIndexes);
}
/**
 * Computes the indices wr to shape of the cartesian products of the slices.
 * We have shape.length==slices.length, and the elements in slices[axis] are
 * integers between 0 and shape[axis]-1
 * @param {number[]} shape
 * @param {number[][]} slices
 * @returns {number[]}
 */
function __slices_to_indices(shape, slices) {
    var e_1, _a;
    try {
        for (var slices_1 = __values(slices), slices_1_1 = slices_1.next(); !slices_1_1.done; slices_1_1 = slices_1.next()) {
            var slice = slices_1_1.value;
            if (slice.length == 0)
                return [];
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (slices_1_1 && !slices_1_1.done && (_a = slices_1.return)) _a.call(slices_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    var shifts = (0, basic_1.shape_shifts)(shape);
    var iShifts = slices.map(function (indices, axis) {
        // out[i] = How much does the cursor increase if we change from [...,indices[i],...] to [...,indices[(i+1)%n],...]
        var out = [], n = indices.length;
        for (var i = 0; i < n - 1; i++)
            out.push(shifts[axis] * (indices[i + 1] - indices[i]));
        out[n - 1] = shifts[axis] * (indices[0] - indices[n - 1]);
        return out;
    });
    var indices = [];
    var lastAxis = shape.length - 1;
    var tuple = new Array(shape.length).fill(0);
    var cursor = slices.map(function (l, i) { return l[tuple[i]] * shifts[i]; }).reduce(function (a, b) { return a + b; }, 0);
    while (true) {
        if (!isFinite(cursor))
            throw new Error("Programming error");
        indices.push(cursor);
        var axis = lastAxis;
        while (axis >= 0) {
            cursor += iShifts[axis][tuple[axis]++];
            if (tuple[axis] < iShifts[axis].length)
                break;
            tuple[axis--] = 0; // Overflow
        }
        ;
        if (axis < 0)
            break;
    }
    return indices;
}
// =========================================
//     Slicing
// =========================================
function __parse_sliceRange(axis_size, _a) {
    var start = _a.start, stop = _a.stop, step = _a.step;
    if (start == null)
        start = 0;
    else if (start < 0)
        start = axis_size + start;
    if (stop == null)
        stop = axis_size;
    else if (stop < 0)
        stop = axis_size + stop;
    if (step == null)
        step = 1;
    else if (step == 0)
        throw new Error("Slice range with step size of zero");
    if (!isFinite(start) || !isFinite(stop) || !isFinite(step))
        throw new Error("Invalid slice ".concat([start, stop, step], ". Axis size ").concat(axis_size));
    var indices = [];
    if (step > 0) {
        start = Math.max(start, 0);
        stop = Math.min(stop, axis_size);
        for (var i = start; i < stop; i += step)
            indices.push(i);
    }
    else {
        stop = Math.max(stop, 0);
        start = Math.min(start, axis_size);
        for (var i = start; i > stop; i += step)
            indices.push(i);
    }
    return indices;
}
exports.__parse_sliceRange = __parse_sliceRange;
var AxisIndex = /** @class */ (function () {
    /**
     * Invariant: Immutable
     */
    function AxisIndex(spec) {
        this.spec = spec;
        this._indices = null;
        this.isSimple = (this.spec.type != "array");
        this.isConstant = (this.spec.type == "number");
    }
    Object.defineProperty(AxisIndex.prototype, "indices", {
        get: function () {
            if (this._indices)
                return this._indices;
            var indices;
            // if (this.spec.type == 'false') indices = []; else
            if (this.spec.type === ':')
                indices = Array.from({ length: this.spec.size }, function (_, i) { return i; });
            else if (this.spec.type === "number")
                indices = [this.spec.index];
            else if (this.spec.type === "array")
                indices = this.spec.indices;
            else if (this.spec.type === false)
                indices = [];
            else if (this.spec.type == "range") {
                var _a = this.spec.range, nSteps = _a.nSteps, step_1 = _a.step, start_1 = _a.start;
                indices = Array.from({ length: nSteps }, function (_, i) { return start_1 + i * step_1; });
            }
            else
                throw new Error("Unknown spec type ".concat(this.spec['type']));
            return this._indices = indices;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AxisIndex.prototype, "size", {
        get: function () {
            if (this.spec.type === ':')
                return this.spec.size;
            else if (this.spec.type === "number")
                return 1;
            else if (this.spec.type === "array")
                return this.spec.indices.length;
            else if (this.spec.type == "range")
                return this.spec.range.nSteps;
            else if (this.spec.type === false)
                return 0;
            else
                throw new Error("Unknown spec type ".concat(this.spec['type']));
        },
        enumerable: false,
        configurable: true
    });
    return AxisIndex;
}());
exports.AxisIndex = AxisIndex;
AxisIndex.prototype.parse_range = function (size, start, stop, step) {
    if (start === void 0) { start = null; }
    if (stop === void 0) { stop = null; }
    if (step === void 0) { step = null; }
    if (step == null)
        step = 1;
    else if (step == 0)
        throw new Error("Index specification error. Step must be different from zero.");
    /**
     *  @param {number|null} i @param {number} ifNull @param {number} min @param {number} max */
    var parse = function (i, ifNull, min, max) {
        if (i == null)
            return ifNull;
        if (i < 0)
            i = Math.max(0, size - i);
        return Math.min(max, Math.max(min, i));
    };
    var nSteps;
    if (step > 0)
        start = parse(start, 0, 0, size - 1), stop = parse(stop, size, 0, size);
    else
        start = parse(start, size - 1, 0, size - 1), stop = parse(stop, size - 1, -1, size - 1);
    stop = Math.max(stop, start);
    nSteps = Math.floor(Math.abs(stop - start) / step);
    return { start: start, step: step, nSteps: nSteps };
};
/**
 *
 * @param {string} rangeString
 * @returns {{start:(number|null), stop:(number|null), step:(number|null)}}
 */
AxisIndex.prototype.parse_range_spec = function (rangeString) {
    var numbers = rangeString.split(':').map(function (s) {
        s = s.trim();
        if (s == "")
            return null;
        var n = parseInt(s);
        if (!Number.isInteger(n))
            throw new Error("Wrong input. Slice index unrecognized: ".concat(s));
        return n;
    });
    if (numbers.length == 0)
        throw new Error('Unexpected empty index. Expected colons.');
    if (numbers.length > 3)
        throw new Error("Too many colons in index ".concat(rangeString));
    var _a = __read(__spreadArray(__spreadArray([], __read(numbers), false), [null, null, null], false)), start = _a[0], stop = _a[1], step = _a[2], _ = _a.slice(3);
    return { start: start, stop: stop, step: step };
};
/**
 * We are reading `indexSpec` and `shape` in parallel, in the reading direction readDir.
 * With respect to `shape` we are at the given `axis`.
 * With respect to `indexSpec`, we found `indexSpec`, which we should process.
 * @param {IndexSpec|undefined} indexSpec
 */
AxisIndex.prototype.parse = function (indexSpec, size) {
    /**
     *
     * span (virtual shape) matches shape unless there are boolean masks spanning
     * over several axes/dimensions.
     * For example, in `np.ones((2,3,4,5))[:, np.arange(12).reshape((3,4))>5, 1]`,
     * the boolean mask is spanning over axes 1 and 2. In this case, the output should
     * merge these axes, resulting in an a vShape of (2, 12, 5).
     * The boolean mask is then converted to indices in the flattened merged axis.
     */
    var spec;
    var span = 1;
    if ((0, basic_1.isarray)(indexSpec) && indexSpec.shape.length == 0) {
        // Unwrap scalar
        //@ts-ignore
        indexSpec = indexSpec.item();
    }
    if (indexSpec == ':' || indexSpec === undefined) {
        spec = { type: ':', size: size };
    }
    else if (typeof indexSpec === "number") {
        var index_3 = indexSpec;
        if (index_3 < 0)
            index_3 = size + index_3;
        if (index_3 < 0 || index_3 >= size)
            throw new Error("Index ".concat(index_3, " out of bounds [0..").concat(size, ")"));
        spec = { type: 'number', index: index_3 };
    }
    else if ((0, basic_1.isarray)(indexSpec) || Array.isArray(indexSpec)) {
        var arr = (0, basic_1.asarray)(indexSpec);
        var indices_1;
        if ((0, dtypes_1.dtype_is_boolean)(arr.dtype)) {
            // Boolean mask
            indices_1 = [];
            arr.flat.forEach(function (if_value, i) { return if_value && indices_1.push(i); });
            // Next lines: the boolean mask spans over more than 1 axis
            span = Math.max(1, arr.shape.length);
            // Multiply the (possibly inverted) interval
        }
        else {
            // Array of indices
            indices_1 = arr.flat;
            if (!(0, dtypes_1.dtype_is_integer)(arr.dtype) && arr.size > 0) {
                // If the array is not integer, we should throw an error. Manual check
                var new_indices = new Int32Array(indices_1);
                if (new_indices.some(function (v, i) { return v != indices_1[i]; }))
                    throw new Error("Expected 1D array of indices or nD array of booleans. " +
                        "Found shape=".concat(arr.shape, " and dtype=").concat(arr.dtype));
                indices_1 = new_indices;
            }
        }
        spec = { type: "array", indices: indices_1 };
    }
    else if (typeof indexSpec == "string") {
        var _a = AxisIndex.prototype.parse_range_spec(indexSpec), start = _a.start, stop_1 = _a.stop, step = _a.step;
        var range = AxisIndex.prototype.parse_range(size, start, stop_1, step);
        if (range.start == 0 && range.nSteps == size && range.step == 1) {
            // Small optimization: all of these are just ":": ["::","0::1", ":axisSize:", etc.]
            spec = { type: ':', size: size };
        }
        else {
            spec = { type: 'range', range: range };
        }
    }
    // else if (typeof indexSpec == "boolean" && indexSpec === false) spec = { type: 'false' };
    else
        throw new Error("Unknown index type. Found ".concat(typeof indexSpec, ": ").concat(indexSpec));
    var axisIndex = new AxisIndex(spec);
    return { axisIndex: axisIndex, span: span };
};
AxesIndex.prototype.parse = function (shape, where) {
    var _where = where == null ? [] : __spreadArray([], __read(where), false);
    var buffers = {
        axisIndexes: [],
        apparentShape: [],
        internalShape: [],
    };
    var readDir = 1;
    var reversedAfter = { axisIndexes: NaN, apparentShape: NaN, internalShape: NaN };
    var axis = 0, j = 0, remainingAxes = shape.length, remainingWhere = _where.length;
    while (remainingWhere > 0 || remainingAxes > 0) {
        var axisWhere = _where[j];
        if (remainingWhere > 0) {
            if (j < 0 || j >= _where.length)
                axisWhere = ":";
            remainingWhere--;
            //else _where[j] = undefined; // For ellipsis to avoid reading twice in opposite reading directions
            j += readDir;
            if (axisWhere == "None" || axisWhere === null || axisWhere === true) {
                buffers.apparentShape.push(1);
                continue;
            }
            else if (axisWhere === false) {
                buffers.apparentShape.push(0);
                continue;
            }
            else if (axisWhere == "...") {
                if (readDir == -1)
                    throw new Error("Index can only have a single ellipsis. Found index(".concat(where, ")"));
                readDir = -1;
                for (var key in reversedAfter)
                    reversedAfter[key] = buffers[key].length;
                j = _where.length - 1;
                axis = shape.length - 1;
                continue;
            }
        }
        else {
            axisWhere = ":"; // If there are no more axes, fill with ":"
        }
        // if (remainingAxes <= 0) throw Error(`Too many axes`);
        var _a = AxisIndex.prototype.parse(axisWhere, shape[axis]), axisIndex = _a.axisIndex, span = _a.span;
        // Advance the axis cursor span axes in readDir and compute the total size of consumed axes
        remainingAxes -= span;
        var refSize = 1;
        for (var i = 0; i < span; i++) {
            if (axis < 0 || axis >= shape.length)
                throw new Error("Index where=".concat(JSON.stringify(where), " spans over more dimensions than available in shape=").concat(JSON.stringify(shape)));
            refSize *= shape[axis];
            axis += readDir;
        }
        buffers.axisIndexes.push(axisIndex);
        if (axisIndex.spec.type != "number")
            buffers.apparentShape.push(axisIndex.size);
        buffers.internalShape.push(refSize);
    }
    if (readDir == -1) { // reverse the right to left elements
        for (var key in buffers)
            buffers[key].splice(0, reversedAfter[key]).concat(buffers[key].reverse());
    }
    var axesIndex = new AxesIndex(buffers.apparentShape, buffers.internalShape, buffers.axisIndexes);
    return axesIndex;
};
